export default __webpack_public_path__ + "static/O0013-d61b6e7618b92a109f36ccad1766cff5.png";